import React from 'react';
import PropTypes from 'prop-types';

const field_struct = {
  _id : '',
  entity : '',
  owners : [],
  account : '',
  flex : 12,
  label : '',
  name : '',
  placeholder : '',
  options : [],
  order : 1,
  type : 'text',
  entity_ref : '',
  is_required : false
}

export const VisibleTypes = [
  ['text', 'Text', 'th-list'],
  ['textarea', 'Text Area', 'paragraph'],
  ['number', 'Number', 'calculator'],
  ['select', 'Select', 'list-alt'],
  ['multiselect', 'Multi-Select', 'list'],
  // ['file', 'Single File','file'],
  // ['files', 'Files','files-o'],
  ['checkbox', 'Checkbox','check-square'],
  ['relationship', 'Relationship', 'link']
]

const constructField = type => {
  switch(type) {
    //TODO: Do custom logic for some types.
    default:
      return {...field_struct, type, _id : `tmp_id_${Date.now()}`}
  }
}

class FieldPicker extends React.Component {
  constructor(props) {
    super(props);

    this.selectField = this.selectField.bind(this);
  }
  selectField(event, type) {
    event.preventDefault();
    this.props.onSelect(constructField(type[0]), type);
  }
  render() {
    return <div className="field-picker">
      <ul className={`list-unstlyed mg-folders`}>
        {VisibleTypes.map((type, index) => {
          return <li key={index} className="menu-item mb-xs"><a className="btn btn-default btn-block" onClick={e => this.selectField(e, type)} href="#"><i className={`fa fa-${type[2]}`}></i> {type[1]}</a></li>
        })}
      </ul>
    </div>
  }
}

FieldPicker.propTypes = {
  onSelect : PropTypes.func,
}

export default FieldPicker;



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/field-picker.js